import { IJobDataArgs, JobData } from "../job-data/job-data.model";

export interface IReportArgs extends IJobDataArgs {
    reportLayout: string;
    job: string;
    title?: string;
    sendEmail?: string;
    message?: string;
    attempted?: string;
    completed?: string;
    succeeded?: boolean;
}

const defaults = {
    reportLayout: "",
    job: "",
    title: "",
    sendEmail: "",
    message: "",
    attempted: "",
    completed: "",
    succeeded: false
} as IReportArgs;

export class Report extends JobData {
    reportLayout: string;
    job: string;
    title: string;
    sendEmail: string;
    message: string;
    attempted: string;
    completed: string;
    succeeded: boolean;

    constructor(data?: IReportArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.model.ts